<template>
  <v-app>
    <meta charset="UTF-8">

    <Header 
      :headerBG="allColors.headerBG" 
      :headerFontMain="allColors.headerFontMain" 
      :headerFontSecond="allColors.headerFontSecond">
    </Header>

    <v-content id="background" :style="'background-image: url(' + backgroundURL + ');'">

      <Content
        :Slides="Slides"
        :Questions="Questions"
        :contentFontMain="allColors.contentFontMain" 
        :contentFontSecond="allColors.contentFontSecond" 
        :sliderQuestionBG="allColors.sliderQuestionBG" 
        :sliderFontQuestion="allColors.sliderFontQuestion" 
        :sliderFontCards="allColors.sliderFontCards" 
        :sliderCardTop="allColors.sliderCardTop" 
        :sliderCardBottom="allColors.sliderCardBottom"
        :sliderCardBorderDefault="allColors.sliderCardBorderDefault"
        :sliderCardBorderSelected="allColors.sliderCardBorderSelected" 
        :progressBar="allColors.progressBar">
      </Content>

    </v-content>

    <Footer 
      :footerTop="allColors.footerTop" 
      :footerTopFont="allColors.footerTopFont"
      :footerBottom="allColors.footerBottom"
      :footerBottomFont="allColors.footerBottomFont"
      :footerButtonBG="allColors.footerButtonBG">
    </Footer>

  </v-app>
</template>

<script>
import Header from './Header.vue';
import Content from './Content.vue';
import Footer from './Footer.vue';

export default {
  name: 'Main',
  components: {
    Header,
    Content,
    Footer,

  },
  props: {
    Slides: {
      type: Array,
      required: true
    },
    Questions: {
      type: Array,
      required: true
    },
    themeMode: {
      type: Boolean,
      required: false,
      default: true
    },
    allColors: {
      type: Object,
      required: false,
      default: () => ({
        // General colors
        lightModeMain: '#ECEFF1',
        lightModeSecond: '#CFD8DC',
        darkModeMain: '#34495E',
        darkModeSecond: '#90A4AE',

        // Header
        headerBG: '#FFF', 
        headerFontMain: '#6E8995', 
        headerFontSecond: '#2980B9', 

        // Content / Slider
        contentFontMain: '#546E7A', 
        contentFontSecond: '#546E7A', 
        sliderQuestionBG: '#ECEFF1',
        sliderFontQuestion: '#2980B9', 
        sliderFontCards: '#FFF', 
        sliderCardTop: '#ECEFF1', 
        sliderCardBottom: '#2980B9', 
        sliderCardBorderDefault: '#546E7A', 
        sliderCardBorderSelected: '#2980B9', 
        progressBar: '#2980B9', 

        // Footer
        footerTop: '#CFD8DC', 
        footerTopFont: '#546E7A', 
        footerBottom: '#ECEFF1', 
        footerBottomFont: '#546E7A',
        footerButtonBG: '#CFD8DC'
      })
    },
    mainColor: {
      type: String,
      required: false,
      default: '#000'
    },
    secondColor: {
      type: String,
      required: false,
      default: '#2980B9'
    },
    darkTheme: {
      type: Boolean,
      required: false,
      default: false
    },
    backgroundURL: {
      type: String,
      required: false,
      default: 'https://i1.wp.com/gabius-onkologie.de/wp-content/uploads/2017/02/grey-white-background.jpg'
    }
  },
  data: () => ({
    model: 0,
    output: [],
  }),
  methods: {
    cardClicked(object) {
      this.output[object.slide] = object.id;
      console.log(this.output);
      window.setTimeout(() => this.model = 1, 700);
    },
    toggleDarkMode() {
      if ( !this.darkTheme ) {
        this.allColors.headerBG = this.allColors.darkModeMain;
        this.allColors.sliderQuestionBG = this.allColors.darkModeSecond;
        this.allColors.sliderCardTop = this.allColors.darkModeMain;
        this.allColors.sliderCardBorderDefault = this.allColors.darkModeMain;
        this.allColors.footerTop = this.allColors.darkModeMain;
        this.allColors.footerBottom = this.allColors.darkModeSecond;
        this.allColors.footerButtonBG = this.allColors.darkModeMain;

        this.allColors.headerFontMain = this.allColors.lightModeMain;
        // this.allColors.contentFontMain = this.allColors.lightModeMain;
        // this.allColors.contentFontSecond = this.allColors.lightModeMain;
        this.allColors.footerTopFont = this.allColors.lightModeMain;
        this.allColors.footerBottomFont = this.allColors.lightModeMain;
      } else {
        this.allColors.headerBG = this.allColors.lightModeMain;
        this.allColors.sliderQuestionBG = this.allColors.lightModeSecond;
        this.allColors.sliderCardTop = this.allColors.lightModeMain;
        this.allColors.sliderCardBorderDefault = this.allColors.darkModeSecond;
        this.allColors.footerTop = this.allColors.lightModeMain;
        this.allColors.footerBottom = this.allColors.lightModeSecond;
        this.allColors.footerButtonBG = this.allColors.lightModeMain;

        this.allColors.headerFontMain = this.allColors.darkModeMain;
        // this.allColors.contentFontMain = this.allColors.darkModeMain;
        // this.allColors.contentFontSecond = this.allColors.darkModeMain;
        this.allColors.footerTopFont = this.allColors.darkModeMain;
        this.allColors.footerBottomFont = this.allColors.darkModeMain;
      }
    },
    toggleColor(color) {
      this.allColors.headerFontSecond = color;
      this.allColors.sliderFontQuestion = color;
      this.allColors.sliderCardBorderSelected = color;
      this.allColors.sliderCardBottom = color;
      this.allColors.progressBar = color;
    }
  },
  created() {
    Event.$on('cardClicked', (event) => this.cardClicked(event));
    Event.$on('Toggle Darkmode', () => this.toggleDarkMode());
    Event.$on('Blue', () => this.toggleColor('#2980B9'));
    Event.$on('Red', () => this.toggleColor('#C0392B'));
    Event.$on('Purple', () => this.toggleColor('#9B59B6'));
    Event.$on('Green', () => this.toggleColor('#27AE60'));
    Event.$on('Yellow', () => this.toggleColor('#FFB300'));
    if ( this.themeMode ) {
      this.allColors.headerFontMain = this.mainColor;
      this.allColors.headerFontSecond = this.secondColor;
      this.allColors.contentFontMain = this.mainColor;
      this.allColors.contentFontSecond = this.mainColor;
      this.allColors.sliderFontQuestion = this.secondColor;
      this.allColors.sliderCardBorderSelected = this.secondColor;
      this.allColors.sliderCardBottom = this.secondColor;
      this.allColors.progressBar = this.secondColor;
      this.allColors.footerTopFont = this.mainColor;
      this.allColors.footerBottomFont = this.mainColor;
      if ( this.darkTheme ) {
        this.allColors.headerBG = this.allColors.darkModeMain;
        this.allColors.sliderQuestionBG = this.allColors.darkModeSecond;
        this.allColors.sliderCardTop = this.allColors.darkModeMain;
        this.allColors.sliderCardBorderDefault = this.allColors.darkModeMain;
        this.allColors.footerTop = this.allColors.darkModeMain;
        this.allColors.footerBottom = this.allColors.darkModeSecond;
        this.allColors.footerButtonBG = this.allColors.darkModeMain;
      } else {
        this.allColors.headerBG = this.allColors.lightModeMain;
        this.allColors.sliderQuestionBG = this.allColors.lightModeSecond;
        this.allColors.sliderCardTop = this.allColors.lightModeMain;
        this.allColors.sliderCardBorderDefault = this.allColors.darkModeSecond;
        this.allColors.footerTop = this.allColors.lightModeMain;
        this.allColors.footerBottom = this.allColors.lightModeSecond;
        this.allColors.footerButtonBG = this.allColors.lightModeMain;
      }
    }
  }
};
</script>

<style>
  #background {
    background-size: cover;
  }
</style>
